import { render, staticRenderFns } from "./AhaGallery.vue?vue&type=template&id=84f2b3ac&scoped=true&"
import script from "./AhaGallery.vue?vue&type=script&lang=js&"
export * from "./AhaGallery.vue?vue&type=script&lang=js&"
import style0 from "./AhaGallery.vue?vue&type=style&index=0&id=84f2b3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f2b3ac",
  null
  
)

export default component.exports